// PaperMaterialsConfig.js
import { TextureLoader } from "three/src/loaders/TextureLoader";

// Texture paths
export const textures = {
  roughness: {
    paper: "/textures/paper/paper01/roughness.jpg",
    canvas: "/textures/paper/paper01/roughness.jpg",
    paperMatt: "/textures/paper/027/roughness.jpg",
    paperSemiGloss: "/textures/paper/033/roughness.jpg",
  },
  normal: {
    paper: "/textures/paper/paper01/normal.jpg",
    canvas: "/textures/paper/paper01/normal.jpg",
    paperMatt: "/textures/paper/027/normal.jpg",
    paperSemiGloss: "/textures/paper/033/normal.jpg",
  },
};

// Material configurations for different paper types
export const materialConfigs = {
  none: {
    transparent: true,
    transmission: 1,
    transmissionDepth: 0.1,
    opacity: 0.1,
    roughness: 0.05,
    color: "white",
    clearcoat: 0.5,
    clearcoatRoughness: 0.05,
  },
  "Paper Matt": {
    transparent: true,
    transmission: 1,
    transmissionDepth: 0.1,
    reflectivity: 0,
    ior: 1,
    opacity: 1,
    roughness: 1,
    color: "white",
    clearcoat: 0.6,
    clearcoatRoughnessMapType: "paperMatt",
    clearcoatRoughness: 0.8,
    normalMapType: "matte",
    normalScale: [1, 1],
    textureScale: 2,
    thickness: 0,
  },
  "Paper Semi Gloss": {
    transparent: true,
    transmission: 1,
    transmissionDepth: 0.1,
    reflectivity: 0,
    ior: 1,
    opacity: 1,
    roughness: 0.4,
    color: "white",
    clearcoat: 0.4,
    clearcoatRoughnessMapType: "paperSemiGloss",
    clearcoatRoughness: 0.5,
    normalMapType: "matte",
    normalScale: [3, 3],
    textureScale: 1,
    thickness: 0,
  },
  "Lamination": {
    transparent: true,
    transmission: 1,
    transmissionDepth: 0.1,
    reflectivity: 0,
    ior: 1,
    opacity: 1,
    roughness: 1,
    color: "white",
    clearcoat: 0.6,
    clearcoatRoughnessMapType: "paperMatt",
    clearcoatRoughness: 0.8,
    normalMapType: "matte",
    normalScale: [1, 1],
    textureScale: 2,
    thickness: 0,
  },
  "Lamination Matt": {
    transparent: true,
    transmission: 1,
    transmissionDepth: 0.1,
    reflectivity: 0,
    ior: 1,
    opacity: 1,
    roughness: 1,
    color: "white",
    clearcoat: 0.6,
    clearcoatRoughnessMapType: "paperMatt",
    clearcoatRoughness: 0.8,
    normalMapType: "matte",
    normalScale: [1, 1],
    textureScale: 2,
    thickness: 0,
  },
  "Lamination Satin": {
    transparent: true,
    transmission: 1,
    transmissionDepth: 0.1,
    reflectivity: 0,
    ior: 1,
    opacity: 1,
    roughness: 0.4,
    color: "white",
    clearcoat: 0.4,
    clearcoatRoughnessMapType: "paperSemiGloss",
    clearcoatRoughness: 0.5,
    normalMapType: "matte",
    normalScale: [3, 3],
    textureScale: 1,
    thickness: 0,
  },
};

// Helper function to create a texture loader
export const createTextureLoader = () => new TextureLoader();
